import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { LATINICA } from './lat';
import { CIRLICA } from './cir';
import { HUNGARY } from './hu';

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'cir', // Default to Cyrillic if no language is detected
    interpolation: {
      escapeValue: false // not needed for React
    },
    resources: {
      cir: {
        translation: CIRLICA // Serbian Cyrillic translations
      },
      lat: {
        translation: LATINICA // Serbian Latin translations
      },
      hu: {
        translation: HUNGARY // Hungary  translations
      }
    }
  });

export default i18n;
